"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core/");
var _ExpansionPanel = _interopRequireDefault(require("@material-ui/core/ExpansionPanel"));
var _ExpansionPanelSummary = _interopRequireDefault(require("@material-ui/core/ExpansionPanelSummary"));
var _ExpansionPanelDetails = _interopRequireDefault(require("@material-ui/core/ExpansionPanelDetails"));
var _lodash = require("lodash");
var _Image = _interopRequireDefault(require("../Image"));
var _Text = _interopRequireDefault(require("../Text"));
var _Truncate = _interopRequireDefault(require("../Truncate"));
var _clsx = _interopRequireDefault(require("clsx"));
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  var transition = {
    duration: theme.transitions.duration.shortest
  };
  return {
    heading: {
      fontSize: theme.typography.pxToRem(20),
      fontWeight: theme.typography.fontWeightMedium
    },
    h3: {
      textAlign: 'left',
      color: theme.palette.primary.main,
      lineHeight: 1.41,
      fontSize: theme.typography.pxToRem(16),
      transition: theme.transitions.create(['color', 'font-size'], transition),
      margin: '0 !important',
      '&$expanded': {
        color: theme.palette.common.black,
        fontSize: theme.typography.pxToRem(18)
      }
    },
    stageTitleLink: {
      display: 'inline-block'
    },
    stageLink: {
      display: 'inline-block'
    },
    indicatorLine: {
      position: 'relative',
      '&::before': {
        position: 'absolute',
        content: "''",
        left: '-1px',
        height: '100%',
        borderLeft: "1px solid ".concat(theme.palette.secondary.main)
      },
      '&$first': {
        '&::before': {
          height: 'calc(100% - 11px)',
          top: '11px'
        }
      },
      '&$last': {
        '&::before': {
          height: '11px',
          top: '0'
        }
      }
    },
    indicatorDot: {
      position: 'absolute',
      width: '13px',
      height: '13px',
      border: "solid 1px ".concat(theme.palette.secondary.main),
      backgroundColor: theme.palette.secondary.main,
      borderRadius: '13px',
      zIndex: 1,
      top: '50%',
      left: '-25px',
      transform: 'translateX(-50%) translateY(-50%)',
      transition: theme.transitions.create(['width', 'height', 'border', 'background-color'], transition),
      '&$expanded': {
        width: '19px',
        height: '19px',
        backgroundColor: 'white',
        borderRadius: '19px',
        border: "solid 3px ".concat(theme.palette.secondary.main)
      }
    },
    imageContainer: {
      width: '30%',
      float: 'right',
      transition: theme.transitions.create(['width'], transition),
      cursor: 'pointer',
      paddingTop: '6px',
      paddingRight: '33px',
      margin: '0 0 15px',
      '&$expanded': {
        width: '100%'
      },
      '&$disabled': {
        cursor: 'auto'
      }
    },
    linkList: {
      margin: '6px 0',
      padding: '0',
      listStyleType: 'none',
      '& > li': {
        margin: '0',
        padding: '0'
      }
    },
    details: {
      '& .aem-ms-text-cmp': {
        margin: 0
      },
      '& a': {
        fontWeight: theme.typography.fontWeightMedium
      }
    },
    expanded: {},
    disabled: {},
    first: {},
    last: {}
  };
});
var imageStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    wrapper: {
      margin: '0',
      '& img': {
        marginBottom: '0px',
        width: '100%'
      }
    },
    expanded: {}
  };
});
var ExpansionPanel = (0, _styles.withStyles)(function (theme) {
  return {
    root: {
      boxShadow: 'none',
      paddingLeft: '25px',
      '&:not(:last-child)': {
        marginBottom: '20px'
      },
      '&:before': {
        display: 'none'
      },
      '&$disabled': {
        backgroundColor: 'white'
      },
      '&$expanded': {
        margin: '0 0 30px'
      },
      margin: '0 0 30px'
    },
    disabled: {},
    expanded: {}
  };
})(_ExpansionPanel.default);
var ExpansionPanelSummary = (0, _styles.withStyles)(function (theme) {
  return {
    root: {
      minHeight: 0,
      padding: 0,
      '&$expanded': {
        minHeight: 0
      },
      '&$disabled': {
        opacity: '1'
      }
    },
    content: {
      paddingRight: '12px',
      margin: 0,
      '&$expanded': {
        margin: 0
      }
    },
    expanded: {},
    disabled: {},
    expandIcon: {
      order: -1,
      marginRight: 0,
      '&$expanded': {}
    }
  };
})(_ExpansionPanelSummary.default);
var ExpansionPanelDetails = (0, _styles.withStyles)(function (theme) {
  return {
    root: {
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: '8px',
      display: 'block',
      width: '100%',
      '&>div': {
        width: '100%'
      }
    }
  };
})(_ExpansionPanelDetails.default);
var StagePanel = function StagePanel(_ref) {
  var stage = _ref.stage,
    expanded = _ref.expanded,
    disabled = _ref.disabled,
    onChange = _ref.onChange,
    first = _ref.first,
    last = _ref.last;
  var classes = useStyles();
  var imageClasses = imageStyles();
  var _React$useState = _react.default.useState((0, _lodash.uniqueId)('accordion-panel-')),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 1),
    uniqueId = _React$useState2[0];
  var toggleExpanded = function toggleExpanded(event) {
    event.stopPropagation();
    if (!disabled) {
      onChange(event, !expanded);
    }
  };
  return __jsx(_react.default.Fragment, null, __jsx(_core.Grid, {
    item: true,
    xs: 12,
    sm: 4
  }, stage.image && stage.image.src && __jsx("div", {
    className: (0, _clsx.default)(classes.imageContainer, expanded && classes.expanded, disabled && classes.disabled),
    onClick: toggleExpanded
  }, __jsx(_Image.default, (0, _extends2.default)({}, stage.image, {
    link: stage.url,
    classesInjected: imageClasses
  })))), __jsx(_core.Grid, {
    className: (0, _clsx.default)(classes.indicatorLine, first && classes.first, last && classes.last),
    item: true,
    xs: 12,
    sm: 8
  }, __jsx(ExpansionPanel, {
    square: true,
    "data-cmp-hook-accordion": "item",
    onChange: onChange,
    expanded: expanded,
    disabled: disabled
  }, __jsx(ExpansionPanelSummary, {
    "data-cmp-hook-accordion": "button",
    "aria-controls": uniqueId,
    id: uniqueId
  }, __jsx("div", {
    className: (0, _clsx.default)(classes.indicatorDot, expanded && classes.expanded)
  }), stage.title && __jsx("h3", {
    className: (0, _clsx.default)(classes.h3, expanded && classes.expanded)
  }, __jsx(_Truncate.default, {
    lineHeight: 1.41
  }, __jsx("span", {
    dangerouslySetInnerHTML: {
      __html: stage.title
    }
  })))), __jsx(ExpansionPanelDetails, {
    "data-cmp-hook-accordion": "panel",
    className: classes.details
  }, stage.itemText && stage.itemText.text && __jsx(_Text.default, stage.itemText), stage.links && __jsx("ul", {
    className: classes.linkList
  }, stage.links.map(function (link, index2) {
    var linkProps = link.external && {
      target: '_blank',
      rel: 'noopener'
    };
    return __jsx("li", {
      key: index2
    }, __jsx(_core.Link, (0, _extends2.default)({
      href: link.linkUrl
    }, linkProps, {
      className: classes.stageLink
    }), __jsx(_Truncate.default, {
      lines: 2
    }, __jsx("span", {
      dangerouslySetInnerHTML: {
        __html: link.linkText
      }
    }))));
  }))))));
};
var _default = StagePanel;
exports.default = _default;